import type { CSSProperties } from 'react';

/** A circle to cut out: where its centre sits (any CSS position, e.g. `'0% 50%'` or `'6px calc(100% - 6px)'`) and its radius in px. */
export type MaskHole = { at: string; radius: number };

/**
 * Cut transparent circles out of an element, so whatever is behind it shows through — a badge's
 * ring on a contact photo, the gap around a dot on a line. One mask layer per hole, composited
 * with `intersect` so every hole applies. The `-webkit-` pair first, for engines that only honour
 * it, then the standard properties: an engine that treats the two as aliases (Chromium 120+) keeps
 * whichever was set last, so the standard keyword wins there. One fallback policy for every call site.
 */
export function radialHoleMask(holes: MaskHole[]): CSSProperties | undefined {
  if (holes.length === 0) return undefined;
  const image = holes
    .map((hole) => `radial-gradient(circle at ${hole.at}, transparent ${hole.radius}px, #000 ${hole.radius}px)`)
    .join(', ');
  return { WebkitMaskImage: image, WebkitMaskComposite: 'source-in', maskImage: image, maskComposite: 'intersect' };
}
